import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    employee: null,
    count: null,
    loading: false,
    error: null,
};

export const getAllCustomerSupportActivityList = createAsyncThunk(
    "getAllCustomerSupportActivityList",
    async (body) => {
        try {
            const response = await instance.get(
                `/crm/customer-support/cs-emp-tracker-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}&employee_id=${body.employee_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const getAllCustomerEmployee = createAsyncThunk(
    "getAllCustomerEmployee",
    async (body) => {
        try {
            const response = await instance.get(
                "/crm/customer-support/get-cs-emp-list"
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const CustomerSupportActivitySlice = createSlice({
    name: "CustomerSupportActivitySlice",
    initialState,

    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllCustomerSupportActivityList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getAllCustomerSupportActivityList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action?.payload?.count;

        });
        builder.addCase(getAllCustomerSupportActivityList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(getAllCustomerEmployee.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getAllCustomerEmployee.fulfilled, (state, action) => {
            state.loading = false;
            state.employee = action.payload;
        });
        builder.addCase(getAllCustomerEmployee.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default CustomerSupportActivitySlice.reducer;
